import React, { useState } from 'react';
import './Support.css';

const FAQS = [
  {
    q: 'How do I reset my progress in an app?',
    a: 'The location differs by app. In PokerTrainer, BlackjackTrainer and BridgeTrainer it lives under Settings (the gear icon). In Where on Earth! it is on the Analysis page. In every case, tap "Reset Progress" to clear all stored session data on your device.',
  },
  {
    q: 'Do the apps work offline?',
    a: 'Yes. All four apps work entirely offline — no internet connection is required to use any feature. Where on Earth! goes further still and ships its map data and satellite imagery inside the app, so it makes no network requests at all.',
  },
  {
    q: 'Are there in-app purchases?',
    a: 'Some apps offer optional in-app purchases — additional modes in the card trainers, or an Unlimited monthly subscription in Where on Earth! that lifts its daily question limit. All core functionality is available without purchasing anything.',
  },
  {
    q: 'The app is not behaving as expected — what should I do?',
    a: 'First try closing and reopening the app. If the issue persists, uninstall and reinstall from the App Store — this will not affect your App Store purchase history. If the problem continues, please get in touch using the contact details below.',
  },
  {
    q: 'Where can I send feedback or feature requests?',
    a: 'We love hearing from users. Email us at the address below or leave a review on the App Store. All feedback is read.',
  },
];

export default function Support() {
  return (
    <div className="prose-page">
      <h1>Support</h1>
      <p className="updated">The Pantry Life — iOS Apps</p>

      <p>
        Having trouble with one of our apps, or want to share feedback? We're here to
        help. Browse the common questions below or get in touch directly.
      </p>

      <div className="contact-card">
        <div className="contact-card-row">
          <EmailIcon />
          <div>
            <div className="contact-label">Email support</div>
            <a href="mailto:support@thepantry.life" className="contact-value">
              support@thepantry.life
            </a>
          </div>
        </div>
      </div>

      <h2>Frequently asked questions</h2>
      <div className="faq-list">
        {FAQS.map((faq, i) => (
          <FaqItem key={i} q={faq.q} a={faq.a} />
        ))}
      </div>

      <h2>Response time</h2>
      <p>
        We aim to respond to all support emails within two business days. We're a small
        team — your patience is appreciated.
      </p>
    </div>
  );
}

function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`faq-item${open ? ' faq-item--open' : ''}`}>
      <button
        className="faq-question"
        onClick={() => setOpen(v => !v)}
        aria-expanded={open}
      >
        {q}
        <ChevronIcon />
      </button>
      {open && <p className="faq-answer">{a}</p>}
    </div>
  );
}

function ChevronIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
      <path d="M4.5 6.75L9 11.25L13.5 6.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function EmailIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <defs>
        <linearGradient id="support-email-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgb(140, 92, 245)" />
          <stop offset="100%" stopColor="rgb(61, 209, 240)" />
        </linearGradient>
      </defs>
      <path d="M2.5 5.5A1.5 1.5 0 014 4h12a1.5 1.5 0 011.5 1.5v9A1.5 1.5 0 0116 16H4a1.5 1.5 0 01-1.5-1.5v-9z" stroke="url(#support-email-grad)" strokeWidth="1.5" />
      <path d="M2.5 6l7.5 5 7.5-5" stroke="url(#support-email-grad)" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

